import request from '@/utils/request'

// 조회
export function getRiskAssessmentCreationList (params, isProgress) {
  return request({
    url: `/api/getRiskAssessmentCreationList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}
export function getRiskAssessmentCreation (params,isProgress) {
  return request({
    url: `/api/getRiskAssessmentCreation`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}
// 위험요인 수
export function getRiskAssessmentCnt (params, isProgress) {
  return request({
    url: `/api/getRiskAssessmentCnt`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}
// 저장
export function saveRiskAssessmentCreation (params, isProgress) {
  return request({
    url: `/api/saveRiskAssessmentCreation`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
} 

